<template>
    <div>
        <div class="income-container">
            <el-form ref="form" :model="form" :inline="true" size="small">
                <el-row>
                    <el-col :span="5">
                        <el-form-item label="审核状态">
                            <el-select v-model="form.region" placeholder="请选择活动区域" style="width: 100%;">
                                <el-option label="区域一" value="shanghai"></el-option>
                                <el-option label="区域二" value="beijing"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申请人">
                            <el-input v-model="form.name" style="width: 100%;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="申请日期">
                            <el-date-picker type="date" placeholder="选择日期" v-model="form.date1"
                                style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="供应商">
                            <el-input v-model="form.name" style="width: 100%;"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" size="small">查询</el-button>
                        <el-button type="primary" size="small" plain>重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div>
                <div class="status-container">
                    <div class="status-item" :class="{ 'active': activeStatus === 'pending' }"
                        @click="setActiveStatus('pending')">
                        待审核（100）
                    </div>
                    <div class="status-item" :class="{ 'active': activeStatus === 'approved' }"
                        @click="setActiveStatus('approved')">
                        已通过（22）
                    </div>
                    <div class="status-item" :class="{ 'active': activeStatus === 'unreceived' }"
                        @click="setActiveStatus('unreceived')">
                        未通过（5）
                    </div>
                    <div class="add-button-container">
                        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddDialog">新增付款</el-button>
                    </div>
                </div>
                <el-table :data="tableData" style="width: 100%" border max-height="500">
                    <el-table-column fixed prop="accountName" label="账户名称">
                    </el-table-column>
                    <el-table-column prop="payee" label="收款人">
                    </el-table-column>
                    <el-table-column prop="payAccount" label="收款账户">
                    </el-table-column>
                    <el-table-column prop="amount" label="金额">
                    </el-table-column>
                    <el-table-column prop="description" label="付款描述">
                    </el-table-column>
                    <el-table-column prop="screenshot" label="快照">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" v-if="scope.row.screenshot">
                                <i class="el-icon-picture"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="approvalStatus" label="审核状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.approvalStatus === 'pending'" style="color: #E6A23C;">待审核</span>
                            <span v-else-if="scope.row.approvalStatus === 'passed'" style="color: #67C23A;">通过</span>
                            <span v-else-if="scope.row.approvalStatus === 'rejected'" style="color: #F56C6C;">驳回</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="applicant" label="申请人">
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" v-if="scope.row.approvalStatus === 'pending'">确认付款</el-button>
                            <el-button type="text" size="small" v-if="scope.row.approvalStatus === 'pending'">驳回</el-button>
                            <el-button type="text" size="small" v-if="scope.row.approvalStatus === 'rejected'" style="color: #F56C6C;">展示驳回原因</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="table-pagination">
                    <el-pagination @current-change="currentChange" :current-page="1" :page-size="10"
                        layout="total, prev, pager, next, jumper" :total="1000">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 添加对话框 -->
        <el-dialog title="新增付款" :visible.sync="addDialogVisible" width="600px">
            <el-form :model="addForm" label-width="100px">
                <el-form-item label="是否为供应商">
                    <el-radio-group v-model="addForm.isSupplier">
                        <el-radio label="true">是</el-radio>
                        <el-radio label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="供应商">
                    <el-input v-model="addForm.supplier" placeholder="请输入供应商"></el-input>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input v-model="addForm.amount" placeholder="请输入金额"></el-input>
                </el-form-item>
                <el-form-item label="付款备注">
                    <el-input v-model="addForm.remark" placeholder="请输入付款备注"></el-input>
                </el-form-item>
                <el-form-item label="快照">
                    <div class="snapshot-upload">
                        <el-button type="primary" size="small">
                            <i class="el-icon-upload"></i> 上传快照
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="收款人">
                    <el-input v-model="addForm.payee" placeholder="请输入收款人"></el-input>
                </el-form-item>
                <el-form-item label="收款账户信息">
                    <el-input v-model="addForm.accountInfo" type="textarea" placeholder="请输入账户、分行等信息"
                        :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveAddForm">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            },
            activeStatus: 'pending',
            addDialogVisible: false,
            addForm: {
                isSupplier: 'true',
                supplier: '',
                amount: '',
                remark: '',
                payee: '',
                accountInfo: ''
            },
            tableData: [
                {
                    accountName: 'XXXX公司',
                    payee: '张三',
                    payAccount: '1234567890',
                    amount: '10000',
                    description: '付款描述',
                    screenshot: true,
                    approvalStatus: 'pending',
                    applicant: '李四'
                },
                {
                    accountName: 'YYYY公司',
                    payee: '王五',
                    payAccount: '0987654321',
                    amount: '20000',
                    description: '付款描述',
                    screenshot: false,
                    approvalStatus: 'passed',
                    applicant: '赵六'
                },
                {
                    accountName: 'ZZZZ公司',
                    payee: '钱七',
                    payAccount: '1357924680',
                    amount: '30000',
                    description: '付款描述',
                    screenshot: true,
                    approvalStatus: 'rejected',
                    applicant: '孙八'
                }
            ]
        }
    },
    methods: {
        currentChange(){},
        setActiveStatus(status) {
            this.activeStatus = status;
        },
        openAddDialog() {
            this.addDialogVisible = true;
        },
        saveAddForm() {
            // 保存逻辑
            console.log('保存数据:', this.addForm);
            // 关闭对话框
            this.addDialogVisible = false;
            // 重置表单
            this.addForm = {
                isSupplier: 'true',
                supplier: '',
                amount: '',
                remark: '',
                payee: '',
                accountInfo: ''
            };
        }
    }
}
</script>
<style scoped lang="scss">
.income-container {}

::v-deep .el-form--inline .el-form-item {
    display: flex;
    align-items: center;

    .el-form-item__label {
        width: 70px;
    }

    .el-form-item__content {
        width: calc(100% - 70px);
    }

}

.status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .status-item {
        padding: 4px 12px;
        margin-right: 8px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 12px;
        border: 1px solid #dcdfe6;

        &:hover {
            background-color: #ecf5ff;
            border-color: #c6e2ff;
        }

        &.active {
            background-color: #409EFF;
            color: white;
            border-color: #409EFF;
            box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
        }
    }

    .add-button-container {
        margin-left: auto;
    }
}

.snapshot-upload {
    width: 100%;
    height: 100px;
    border: 1px dashed #dcdfe6;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f7fa;
}
.table-pagination{
  margin-top: 15px;
  text-align: right;
}
</style>
